var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-col',{staticClass:".m-admin-container"},[_c('v-tabs',{attrs:{"optional":"","show-arrows":""}},_vm._l((_vm.tabs),function({ title, link, sentryTag }){return _c('v-tab',{key:title,attrs:{"sentry-tag":sentryTag,"to":link}},[_vm._v(" "+_vm._s(title)+" ")])}),1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }